import { render, staticRenderFns } from "./profilesList.vue?vue&type=template&id=41cba113"
import script from "./profilesList.vue?vue&type=script&lang=js"
export * from "./profilesList.vue?vue&type=script&lang=js"
import style0 from "./profilesList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports